import { Select, SelectProps, Button } from "antd";
import { useCallback } from "react";
import { useRequest } from "../../hooks";
import { searchGateway } from "../../api/gateway";

const cachedData = {
    data: null as any
}

export default function GatewaySelect(p: SelectProps & { isArrayValue?: boolean, plain?: boolean }) {
    const fetchData = useCallback(async () => {
        if (cachedData.data) return cachedData.data;
        const res = await searchGateway({
            pageSize: 1000,
            pageNum: 1,
        });
        cachedData.data = res;
        return res;
    }, []);
    const { data, loading } = useRequest<PagedData<Gateway>>(fetchData);
    return p.plain ?
        <Button type='text'>{data?.data.find(i => i.mac === p.value)?.name || null}</Button> :
        p.isArrayValue ? (
            <Select
                placeholder={'请选择网关'}
                options={data?.data.map(i => {
                    return {
                        value: i.mac,
                        label: i.name
                    }
                })}
                loading={loading}
                showSearch
                {...p}
                mode='multiple'
                value={p.value?.length ? p.value.map((i: any) => i?.mac) : []}
                onChange={(_, options: any[]) => {
                    p.onChange?.(options.map(i => ({
                        name: i.label, mac: i.value
                    })), options)
                }}
            />
        ) : (
            <Select
                placeholder={'请选择网关'}
                options={data?.data.map(i => {
                    return {
                        value: i.mac,
                        label: i.name
                    }
                })}
                loading={loading}
                showSearch
                {...p}
            />
        )
}